import Cookie from 'js-cookie';

const log = (...params) => {
  // eslint-disable-next-line no-console
  if (Cookie.get('chatDev') === 'true') console.log('Chat debug : ', params);
};

export default log;
